import './fontSettings.scss';

export const FontSettingsTemplate = (model) => {
	const { subtitle } = model;
	/* html */
	const html = `
		<div class="engt-font-settings-wrapper">
			<span class="engt-font-settings-sub-title">${subtitle}</span>
			<div class="engt-font-settings-options">
				<button class="engt-font-settings-option"></button>
				<button class="engt-font-settings-option"></button>
				<button class="engt-font-settings-option"></button>
			</div>
		</div>
		<div class="engt-font-settings-cta"></div>
	`;

	return html;
};
